<script>
    import { reloadPieces, } from "../http";
    export let employee;
</script>

<button type="submit" class="button is-info has-text-weight-bold my-2"
    name="reload_pieces" id="reload-pieces-{employee.employee_email}"
    on:click="{reloadPieces(employee)}">
    Załaduj zadania ponownie
</button>
